import Cookies from 'js-cookie';
import { jwtDecode, JwtPayload } from 'jwt-decode';
import memoizeOne from 'memoize-one';

type AgentDetails = {
    /** Also known as agentId */
    userId: number;
    userName: string;
    userEmail: string;
    agencyId: number;
    agencyName: string;
};

interface EtsJWTPayload extends JwtPayload {
    user_id: number;
    user_name: string;
    user_email: string;
    agency_id: number;
    agency_name: string;
    iat: number;
    exp: number;
}

const memoizedDecode = /* #__PURE__ */ memoizeOne(jwtDecode<EtsJWTPayload>);

export const ETS_TOKEN_NAME = /* #__PURE__ */ 'ets_token';

export const getETSUserCookiePayload = (): AgentDetails | null => {
    const authToken = Cookies.get(ETS_TOKEN_NAME);
    if (!authToken) {
        return null;
    }

    const { user_id, user_name, user_email, agency_id, agency_name } =
        memoizedDecode(authToken);
    return {
        userId: user_id,
        userName: user_name,
        userEmail: user_email,
        agencyId: agency_id,
        agencyName: agency_name,
    };
};
